'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isAssignmentMessageV2 = exports.isOfflineMessage = exports.isChatMessage = exports.isInitialMessage = exports.isType = undefined;
exports.isAutomatedChatMessage = isAutomatedChatMessage;
exports.isConversationalMessage = isConversationalMessage;
exports.isPresentationalMessage = isPresentationalMessage;

var _curry = require('transmute/curry');

var _curry2 = _interopRequireDefault(_curry);

var _messageTypeGroups = require('../constants/messageTypeGroups');

var _messageTypes = require('../constants/messageTypes');

var _commonMessageFormatGetters = require('../../common-message-format/operators/commonMessageFormatGetters');

var _messageTypes2 = require('../../common-message-format/constants/messageTypes');

var _isEmailCMF = require('../../common-message-format/operators/isEmailCMF');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var isType = exports.isType = (0, _curry2.default)(function (type, message) {
  return (0, _commonMessageFormatGetters.getType)(message) === type;
});

var isInitialMessage = exports.isInitialMessage = isType(_messageTypes.INITIAL_MESSAGE);

var isChatMessage = exports.isChatMessage = function isChatMessage(message) {
  return isType(_messageTypes.CHAT_MESSAGE, message) || isType(_messageTypes2.COMMON_MESSAGE, message) && !(0, _isEmailCMF.isEmailCMF)(message);
};

var isOfflineMessage = exports.isOfflineMessage = isType(_messageTypes.OFFLINE);

var isAssignmentMessageV2 = exports.isAssignmentMessageV2 = isType(_messageTypes.ASSIGNMENT_V2);

function isAutomatedChatMessage(message) {
  var type = (0, _commonMessageFormatGetters.getType)(message);
  return _messageTypeGroups.AUTOMATED_CHAT_MESSAGE_TYPES.includes(type);
}

function isConversationalMessage(message) {
  var type = (0, _commonMessageFormatGetters.getType)(message);
  return _messageTypeGroups.CONVERSATIONAL_MESSAGE_TYPES.includes(type);
}

function isPresentationalMessage(message) {
  var type = (0, _commonMessageFormatGetters.getType)(message);
  return _messageTypeGroups.PRESENTATIONAL_MESSAGE_TYPES.includes(type);
}


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-schema/static-2.2846/js/pubnub-message/operators/messageTypeComparators.js
// module id = 19
// module chunks = 2 3